import {ReportModalBody} from '@esgi/deprecated/ui-kit/report/modal';
import {styled} from '@esgi/ui/theme';

export const ReportModlaBodyStyled = styled(ReportModalBody, {
	padding: 0,
	minWidth: '500px',
});

export const StudentProgressReportWrapper = styled('div', {
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	boxSizing: 'border-box',
	position: 'relative',
	overflow: 'hidden',
	fontSize: '14px',
	textAlign: 'left',
	backgroundColor: 'white',
	maxHeight: '100%',
});
export const StudentProgressReportContainer = styled('div', {
	padding: '0 20px 20px 20px',
	textAlign: 'center',
	height: 'auto',
	overflow: 'auto',
	minHeight: '100px',

	'@media (max-width: 1220px)': {
		width: '100%',
	},
});